type LeaveConfirmCallback = (result: boolean) => void;

let pendingCallback: LeaveConfirmCallback | null = null;
const listeners: Array<() => void> = [];

export function setPendingLeaveConfirmation(
  callback: LeaveConfirmCallback
): void {
  pendingCallback = callback;
  listeners.forEach((listener) => listener());
}

export function hasPendingLeaveConfirmation(): boolean {
  return pendingCallback !== null;
}

export function resolveLeaveConfirmation(result: boolean): void {
  if (pendingCallback) {
    pendingCallback(result);
    pendingCallback = null;
    listeners.forEach((listener) => listener());
  }
}

export function subscribeToLeaveConfirmation(listener: () => void): () => void {
  listeners.push(listener);
  return () => {
    const index = listeners.indexOf(listener);
    if (index >= 0) listeners.splice(index, 1);
  };
}
